// extracted by mini-css-extract-plugin
module.exports = {"modal-card":"UploadHistoryButton_modal-card_1BEea","modal-card-body":"UploadHistoryButton_modal-card-body_3w3Py","spinAround":"UploadHistoryButton_spinAround_3Lh16"};